import type { Token } from '@uniswap/sdk-core';
import type { TokenInfo } from '@uniswap/token-lists/src/types';

import type { PoolData } from 'graphql/api/pools/pool.types';

type transformPoolDataProps = {
  data:
    | {
        [address: string]: PoolData;
      }
    | undefined;
  cosmicPoolIds: string[];
  myPositionIds: string[];
  tokensFromMap: {
    [address: string]: Token;
  };
};

export const transformPoolData = ({
  data,
  cosmicPoolIds,
  myPositionIds,
  tokensFromMap
}: transformPoolDataProps) =>
  data
    ? Object.values(data).map((pool) => {
        const token0 = tokensFromMap[
          pool.token0.address.toUpperCase()
        ] as Token & {
          tokenInfo: TokenInfo;
        };

        const token1 = tokensFromMap[
          pool.token1.address.toUpperCase()
        ] as Token & {
          tokenInfo: TokenInfo;
        };

        const tvl = pool.tvlUSD;
        const apr = pool.tvlUSD
          ? ((pool.volumeUSDWeek * pool.feeTier) / pool.tvlUSD) *
            (365 / 7) *
            (1 / 10000)
          : 0;
        const adjustedAPR = apr < 0 || apr > 1000 ? 0 : Math.abs(apr);

        const fee = pool.feeTier / 10000;

        const isCosmic = cosmicPoolIds?.includes(pool.address);
        const hasMyPosition = myPositionIds?.includes(pool.address);

        return {
          pool: {
            address: pool.address,
            token0: {
              symbol: pool.token0.symbol,
              address: pool.token0.address,
              isNative: token0?.isNative,
              backupImg: token0?.tokenInfo?.logoURI
            },
            token1: {
              symbol: pool.token1.symbol,
              address: pool.token1.address,
              isNative: token1?.isNative,
              backupImg: token1?.tokenInfo?.logoURI
            },
            isCosmic,
            hasMyPosition,
            fee,
            tvl: tvl < 0 ? 0 : tvl
          },
          volume24h: pool.volumeUSD,
          volume7d: pool.volumeUSDWeek,
          tvl: tvl < 0 ? 0 : tvl,
          apr: adjustedAPR
        };
      })
    : [];
